import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaroSphereXgLogoMiniWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 31 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "_Library Components",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Grid",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Grid_2",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Library/Sphere XG Logo",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Logo type=Logomark - white",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group",
							children: [
								/* @__PURE__ */ _jsx("path", {
									id: "Vector",
									d: "M1.67597 20.6018C1.65993 21.2565 1.76147 21.9432 1.95118 22.4803C2.36267 23.6426 3.3433 24.4495 4.11818 22.9425C4.78885 21.3153 4.43347 19.1269 3.68264 18.3253C2.77683 17.3634 1.72406 18.5524 1.67597 20.6018Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_2",
									d: "M3.81914 17.8571C4.00083 19.3294 5.19522 20.3528 6.47244 18.7496C7.49047 17.2265 7.26869 15.5352 6.78506 14.8217C5.93536 13.5632 4.27338 14.5759 3.87258 16.5959C3.79242 17.0048 3.77104 17.475 3.81914 17.8571Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_3",
									d: "M4.13943 25.3923C4.64444 27.0169 6.25833 28.3048 7.14009 26.7123C7.75733 25.2453 7.09467 23.3081 6.09267 22.5546C4.87156 21.6381 3.74398 22.7523 3.97644 24.6441C4.00316 24.8659 4.06996 25.1732 4.13943 25.3923Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_4",
									d: "M2.00712 18.7073C2.64305 17.3713 2.84345 15.0814 2.38387 14.4053C1.95368 13.7721 1.17078 14.8489 0.834108 16.5403C0.641723 17.5129 0.639052 18.4935 0.831436 19.0439C0.871516 19.1615 1.25896 20.1689 2.00712 18.7073Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_5",
									d: "M2.8596 26.7369C3.01457 25.1444 2.2771 22.8972 1.61177 22.3815C0.970491 21.8845 0.63649 23.0094 0.938427 24.6554C1.11211 25.5933 1.46748 26.5285 1.84958 27.0415C1.98051 27.2179 2.64584 28.0301 2.8596 26.7369Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_6",
									d: "M6.11436 20.6467C6.10635 20.799 6.11169 21.0021 6.12505 21.1544C6.31209 23.1317 8.15844 24.3501 9.44902 22.7443C10.2426 21.6461 10.1411 19.8211 9.22725 18.8405C7.99278 17.5125 6.21857 18.5439 6.11436 20.6467Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_7",
									d: "M4.47096 14.7072C5.49969 13.3231 5.66535 11.7225 5.38746 11.0973C4.97864 10.1755 3.70944 11.0893 3.04411 12.7833C2.7021 13.6571 2.71011 14.285 2.73149 14.5175C2.80363 15.3431 3.40483 15.9737 4.47096 14.7072Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_8",
									d: "M5.90314 30.2479C6.07682 29.0135 5.04008 26.8892 4.02472 26.3949C3.12692 25.9567 2.7475 26.9747 3.26052 28.447C3.4155 28.8879 3.63728 29.3261 3.9018 29.7162C4.59118 30.7236 5.67067 31.469 5.90314 30.2479Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_9",
									d: "M0.000639616 20.5859C0.0139996 21.9139 0.18768 23.1564 0.396096 23.4129C0.599169 23.6614 0.700705 22.9533 0.735441 22.7208C0.922481 21.2539 0.740785 18.6861 0.425488 18.2907C0.185008 17.9914 -0.0127204 19.0655 0.000639616 20.5859Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_10",
									d: "M7.18286 12.8345C7.08934 13.1204 7.0359 13.4009 7.03056 13.6761C6.99315 15.1698 8.32381 15.9206 9.68118 14.6167C10.5042 13.759 10.7874 12.3695 10.3091 11.5225C9.61171 10.2907 7.77337 11.0629 7.18286 12.8345Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_11",
									d: "M10.6538 30.103C11.2096 28.8792 10.448 27.2867 9.39793 26.6775C8.12339 25.94 7.03855 26.8885 7.39927 28.4303C7.7787 30.0602 9.74262 31.5913 10.6538 30.103Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_12",
									d: "M1.18443 26.4484C0.93326 26.3309 1.13633 27.2313 1.63065 28.4177C2.14902 29.6629 2.72083 30.5981 2.93192 30.6943C3.11094 30.7744 2.99337 30.3175 2.94528 30.1224C2.54181 28.709 1.53713 26.6141 1.18443 26.4484Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_13",
									d: "M1.36324 14.5714C2.07399 13.1579 2.66451 11.1753 2.53091 10.9001C2.41601 10.6649 1.8923 11.536 1.41134 12.7651C0.9758 13.8767 0.708599 14.9588 0.812808 15.1806C0.919688 15.4024 1.25369 14.7771 1.36324 14.5714Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_14",
									d: "M12.618 18.4688C13.636 17.2317 13.302 15.9625 12.9413 15.4067C11.9313 13.8489 9.75894 14.6051 9.41693 16.6358C9.39555 16.7667 9.37952 16.9404 9.37952 17.074C9.37685 18.875 11.143 19.9544 12.618 18.4688Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_15",
									d: "M6.30368 9.36057C6.0632 9.79076 5.92159 10.2477 5.9109 10.6111C5.88418 11.4527 6.5789 11.9765 7.76527 10.9183C8.60428 10.1194 9.1173 8.79678 8.86346 8.08602C8.51877 7.12677 7.04383 8.02724 6.30368 9.36057Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_16",
									d: "M12.9943 26.4426C13.9054 25.1333 13.2027 23.7118 12.5454 23.124C11.2308 21.9456 9.44853 22.8487 9.52068 24.6604C9.59015 26.3838 11.5968 28.0378 12.9943 26.4426Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_17",
									d: "M6.83039 32.2116C7.51977 33.3178 9.16038 34.5229 9.4356 33.3071C9.55316 32.1127 8.4042 30.579 7.41556 30.2076C6.45364 29.8469 6.06086 30.6805 6.63534 31.8589C6.68878 31.9684 6.76626 32.1074 6.83039 32.2116Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_18",
									d: "M5.65204 33.732C6.14369 33.9939 6.00475 33.4728 5.95932 33.3018C5.64403 32.2517 4.24924 30.2771 3.59193 30.1275C3.1457 30.026 3.3087 30.8302 3.93929 31.8483C4.52446 32.7915 5.25926 33.5209 5.65204 33.732Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_19",
									d: "M2.87865 11.2651C2.89735 11.4201 3.02026 11.8503 3.87531 10.9124C4.87998 9.71801 5.48385 8.20833 5.38499 7.81287C5.27276 7.3613 4.34023 8.16023 3.60543 9.34126C3.055 10.231 2.84391 10.9471 2.87865 11.2651Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_20",
									d: "M16.2064 22.3888C17.1844 21.2131 16.7248 19.9172 16.177 19.3321C14.9559 18.0254 12.9466 18.8297 12.8183 20.6787C12.813 20.7402 12.813 20.823 12.813 20.8872C12.8477 22.648 14.7823 23.7916 16.2064 22.3888Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_21",
									d: "M9.51295 35.9814C9.10413 34.9527 7.58109 33.4831 6.92645 33.4858C6.49626 33.4884 6.66192 34.1163 7.2845 34.8618C7.74141 35.4069 8.39872 35.952 8.91977 36.2192C9.44348 36.4891 9.64388 36.4089 9.51295 35.9814Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_22",
									d: "M7.24216 7.54825C8.15866 6.78139 8.89079 5.57097 8.82666 5.15414C8.74917 4.65447 7.59754 5.40263 6.82533 6.30577C6.39246 6.81345 6.1119 7.32113 6.07182 7.66048C6.03174 8.02387 6.30963 8.29374 7.24216 7.54825Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_23",
									d: "M11.1026 9.38168C11.0117 9.60078 10.9583 9.81721 10.9449 10.0256C10.8674 11.2975 12.2302 11.7304 13.299 10.7765C14.2395 9.86264 14.154 8.91942 13.9536 8.50526C13.3791 7.31088 11.6664 8.02964 11.1026 9.38168Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_24",
									d: "M14.2772 33.1221C14.7421 32.2323 14.1596 31.0887 13.3233 30.581C12.1396 29.8622 11.0521 30.581 11.4128 31.8422C11.7628 33.074 13.4969 34.239 14.2772 33.1221Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_25",
									d: "M11.4531 7.47869C12.3589 6.70648 12.554 5.85411 12.4631 5.46667C12.2627 4.6143 10.8786 5.25024 10.1598 6.29499C9.91401 6.65037 9.82584 6.93093 9.79377 7.10461C9.64681 7.92491 10.3976 8.26693 11.4531 7.47869Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_26",
									d: "M13.0612 35.9226C13.1574 35.0729 12.1314 33.8171 11.1668 33.6033C10.3812 33.4297 10.1007 34.0389 10.587 34.8565C11.1988 35.8799 12.8074 36.8525 13.0612 35.9226Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_27",
									d: "M16.6794 29.831C17.4222 28.8744 16.9386 27.811 16.4309 27.33C15.2633 26.2185 13.489 26.9052 13.5986 28.4229C13.7055 29.9219 15.5358 31.0014 16.6794 29.831Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_28",
									d: "M16.6551 12.0139C15.8775 10.6539 13.7853 11.1963 13.4113 12.8529C13.3872 12.9571 13.3685 13.0987 13.3632 13.2056C13.3017 14.6485 14.9049 15.5062 16.2516 14.3252C17.2937 13.2163 16.7219 12.1315 16.6551 12.0139Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_29",
									d: "M4.82353 7.46604C5.45145 6.82476 6.81417 5.24294 6.79547 5.06391C6.6966 5.0078 5.99387 5.6571 5.43275 6.27433C4.83689 6.92897 4.22233 7.73592 4.26775 7.89356C4.33723 7.9283 4.5403 7.7466 4.82353 7.46604Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_30",
									d: "M4.89302 33.5661C4.86095 33.6917 5.37932 34.3169 5.88433 34.8433C6.64852 35.6396 7.45814 36.3049 7.56235 36.2675C7.56769 36.2247 7.51158 36.1419 7.3192 35.9148C6.88099 35.4124 5.09342 33.4913 4.89302 33.5661Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_31",
									d: "M16.9597 24.6848C16.8769 26.3147 18.8381 27.2098 20.0031 26.0742C20.8501 25.147 20.46 24.1664 20.0966 23.7335C19.0358 22.4723 17.0425 23.0789 16.9597 24.6848Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_32",
									d: "M19.9175 18.0744C20.7886 17.1151 20.4145 16.1265 20.0591 15.6909C19.0437 14.4645 17.0852 15.0443 16.8821 16.6315C16.8767 16.6822 16.8714 16.7491 16.8687 16.8025C16.826 18.1706 18.488 19.3649 19.9175 18.0744Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_33",
									d: "M13.1603 38.1431C12.7915 37.4217 11.4796 36.4197 10.8944 36.4143C10.5016 36.4116 10.6379 36.8552 11.1883 37.3682C11.5571 37.7129 12.0701 38.0523 12.527 38.2527C12.9011 38.4183 13.3152 38.5359 13.1603 38.1431Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_34",
									d: "M10.8572 38.138C10.1331 37.4834 8.65544 36.4039 8.34014 36.4066C8.14775 36.4093 8.47107 36.8181 9.19251 37.3605C9.99144 37.9617 10.9694 38.4747 11.0576 38.3839C11.0549 38.3358 11.0148 38.2877 10.8572 38.138Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_35",
									d: "M11.0012 4.60671C11.9551 3.93871 12.388 3.20124 12.396 2.96877C12.412 2.54125 11.3513 3.0516 10.6191 3.7196C10.2664 4.04025 10.0259 4.36356 9.95647 4.60404C9.8576 4.94605 10.1168 5.17317 11.0012 4.60671Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_36",
									d: "M8.22528 4.60132C9.09635 3.98408 10.1491 3.01147 10.1785 2.84314C10.2106 2.66144 9.35286 3.13973 8.62074 3.70887C7.95541 4.22723 7.56262 4.67613 7.5172 4.84981C7.49048 4.95669 7.54659 5.06357 8.22528 4.60132Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_37",
									d: "M15.1186 6.33299C15.0786 6.43453 15.0385 6.57347 15.0278 6.67233C14.9049 7.62624 16.0191 8.00299 16.8608 7.29491C17.5983 6.61088 17.3658 5.94288 17.3097 5.81462C16.9329 4.93019 15.5595 5.25617 15.1186 6.33299Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_38",
									d: "M16.9812 33.9753C16.1716 33.5238 15.2337 33.9165 15.4929 34.8517C15.7281 35.6934 16.9705 36.479 17.6011 35.7228C17.9966 35.1029 17.5985 34.32 16.9812 33.9753Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_39",
									d: "M17.7879 31.8476C17.8227 32.919 19.156 33.6699 20.0805 32.8389C20.5748 32.3472 20.5401 31.5456 20.0084 31.054C19.2094 30.3165 17.7478 30.6665 17.7879 31.8476Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_40",
									d: "M17.5608 9.3977C17.5528 9.43511 17.5448 9.48587 17.5421 9.52328C17.4272 10.6322 18.7526 11.3643 19.8267 10.4558C20.305 10.0069 20.3932 9.30418 20.0351 8.78848C19.3698 7.82656 17.7987 8.214 17.5608 9.3977Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_41",
									d: "M16.364 38.0527C16.4735 37.569 15.7815 36.7006 15.0173 36.559C14.4989 36.4628 14.1997 36.7995 14.5925 37.3793C15.0253 38.0206 16.177 38.6298 16.364 38.0527Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_42",
									d: "M15.0518 4.48923C15.8401 3.87734 15.7626 3.26812 15.7599 3.24407C15.6664 2.60279 14.6083 2.99558 14.0579 3.72503C13.8815 3.96017 13.8201 4.14454 13.7987 4.25943C13.6945 4.8446 14.3865 4.97019 15.0518 4.48923Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_43",
									d: "M12.0702 2.24229C12.6287 1.95639 13.7562 1.23495 13.7509 1.12005C13.6707 1.06127 12.9653 1.34717 12.3775 1.6785C11.795 2.00716 11.4583 2.29306 11.4263 2.40796C11.4102 2.47476 11.469 2.54423 12.0702 2.24229Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_44",
									d: "M14.5472 39.7811C14.0769 39.4818 12.5699 38.6561 12.3401 38.7229C12.2279 38.755 12.5084 39.0088 13.0936 39.3161C13.7376 39.6555 14.5499 39.9521 14.7075 39.9334C14.7102 39.928 14.7128 39.92 14.7155 39.9147C14.6941 39.8799 14.6621 39.8559 14.5472 39.7811Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_45",
									d: "M21.1656 20.6956C21.0481 22.0262 22.6245 22.9935 23.7922 21.9193C24.4201 21.2674 24.3106 20.3642 23.8911 19.8432C23.02 18.7637 21.2859 19.3061 21.1656 20.6956Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_46",
									d: "M21.307 28.4494C21.2001 29.5049 22.488 30.2691 23.4874 29.4301C23.971 28.9838 24.0512 28.249 23.6664 27.7601C22.9637 26.8623 21.4219 27.3138 21.307 28.4494Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_47",
									d: "M23.5276 13.8926C24.1315 13.1979 23.8055 12.4791 23.5169 12.1638C22.7287 11.3061 21.3072 11.739 21.211 12.8639C21.1175 13.9568 22.5577 14.7877 23.5276 13.8926Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_48",
									d: "M14.8464 38.7765C14.63 38.8059 14.7583 39.0437 15.135 39.3162C15.4851 39.5701 15.9527 39.7785 16.2305 39.856C16.618 39.9629 16.5271 39.8052 16.4924 39.7464C16.1931 39.3323 15.2259 38.723 14.8464 38.7765Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_49",
									d: "M14.6806 2.20223C15.3112 1.8335 15.6693 1.3846 15.6826 1.24833C15.7094 1.00517 14.9666 1.2991 14.4455 1.68119C14.1917 1.86823 14.0073 2.06329 13.9539 2.19956C13.8764 2.4053 14.0848 2.5202 14.6806 2.20223Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_50",
									d: "M25.5369 24.7215C25.5342 24.7509 25.5289 24.791 25.5289 24.8231C25.4968 25.6701 26.4347 26.2178 27.1855 25.5445C27.5703 25.1624 27.6371 24.5612 27.3432 24.1444C26.8248 23.4096 25.6571 23.781 25.5369 24.7215Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_51",
									d: "M25.5208 16.6626C25.5208 16.692 25.5208 16.7348 25.5208 16.7642C25.5608 17.6486 26.5896 18.2284 27.2869 17.5123C27.6477 17.1009 27.6129 16.4302 27.2095 16.0187C26.5869 15.3881 25.5608 15.7782 25.5208 16.6626Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_52",
									d: "M15.8965 0.505404C16.1931 0.398524 16.9706 0.0725396 17.0481 0.0110836C17.0481 0.00841155 17.0481 0.00306749 17.0481 0.000395488C16.9813 -0.00762052 16.5538 0.107276 16.1744 0.248892C15.7843 0.39318 15.4877 0.548156 15.501 0.598924C15.5438 0.622972 15.6908 0.577548 15.8965 0.505404Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_53",
									d: "M19.8029 4.26458C20.1689 3.90653 20.0113 3.57253 19.9552 3.47634C19.6506 2.97133 18.8944 3.2225 18.7341 3.74888C18.7234 3.78362 18.7127 3.83171 18.71 3.86645C18.6619 4.36879 19.2845 4.68141 19.8029 4.26458Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_54",
									d: "M20.0755 36.9438C19.624 36.6232 19.0495 36.8744 19.1163 37.3633C19.1778 37.8122 19.8137 38.2264 20.2305 37.8229C20.4897 37.505 20.3454 37.1335 20.0755 36.9438Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_55",
									d: "M18.0527 2.05275C18.4001 1.7909 18.3867 1.53706 18.3814 1.48896C18.336 1.14427 17.7802 1.32062 17.513 1.68669C17.4382 1.78823 17.4168 1.86839 17.4088 1.90045C17.3446 2.18101 17.6573 2.31194 18.0527 2.05275Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_56",
									d: "M21.5822 34.8568C21.5154 35.3859 22.154 35.8802 22.7659 35.3939C23.1534 35.0278 23.0331 34.6351 22.9155 34.4774C22.5468 33.9884 21.6624 34.2396 21.5822 34.8568Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_57",
									d: "M22.7419 6.92397C23.0946 6.5018 22.798 6.09832 22.7339 6.02084C22.285 5.47308 21.4299 5.67882 21.3899 6.34682C21.3525 6.96138 22.2075 7.43433 22.7419 6.92397Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_58",
									d: "M18.3306 38.945C18.0474 38.8969 17.9325 39.0813 18.0955 39.3244C18.2986 39.6263 18.849 39.9042 18.9612 39.6317C19.0334 39.4153 18.7074 39.0091 18.3306 38.945Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_59",
									d: "M25.1386 31.8694C25.1332 31.8881 25.1279 31.9122 25.1252 31.9309C25.0451 32.4466 25.5795 32.7779 26.1005 32.3771C26.4666 32.0404 26.3998 31.6744 26.3116 31.5274C26.0684 31.1106 25.2882 31.2575 25.1386 31.8694Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_60",
									d: "M26.2877 9.94261C26.4881 9.68877 26.408 9.26392 26.1087 9.01542C25.6545 8.636 25.0559 8.87648 25.0907 9.42424C25.1281 9.98536 25.8736 10.4022 26.2877 9.94261Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_61",
									d: "M17.8337 0.43905C18.0875 0.31881 18.2852 0.155818 18.3039 0.0997056C18.336 0.0115295 18.01 0.11841 17.7749 0.257354C17.644 0.33217 17.5558 0.406986 17.5371 0.457754C17.5157 0.511194 17.5932 0.543258 17.8337 0.43905Z",
									fill: "white"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Vector_62",
									d: "M30.6431 20.3957C30.3572 20.0243 29.8254 20.2354 29.7773 20.7378C29.7747 20.7725 29.7747 20.8179 29.7747 20.85C29.8067 21.3443 30.3197 21.5661 30.6217 21.2187C30.8622 20.9061 30.766 20.5561 30.6431 20.3957Z",
									fill: "white"
								})
							]
						})
					})
				})
			})
		})
	})
});
export default SvgFaroSphereXgLogoMiniWhite;
